import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import {
  Row,
  Col,
  Alert,
  Card,
  CardBody,
  Container,
  FormFeedback,
  Input,
  Label,
  Form,
} from "reactstrap"

//redux
import { useSelector, useDispatch } from "react-redux"
import { createSelector } from "reselect"
import { Link } from "react-router-dom"
import withRouter from "components/Common/withRouter"

// Formik Validation
import * as Yup from "yup"
import { Formik, useFormik } from "formik"

// action
import { userForgetPassword } from "../../store/actions"

// import images
import logo from "../../assets/images/logo-light.svg"
import { useTranslation } from "react-i18next"
import loginBg from "assets/images/login/login-bg.webp"
import SAR_logo from "assets/images/login/sar-logo-2.svg"
import alyamama_logo from "assets/images/login/alyamama_logo.svg"
import rightVector from "assets/images/login/login_right_vector.webp"
import { InputOtp } from "primereact/inputotp"
import ConfirmPassword from "./ConfirmPassword"
import { forgotPassword, otpVerification } from "store/actions/authAction"
import { showAlert } from "store/reducers/alertReducer"
import {
  arabicEnglishDigitRegex,
  convertArabicToNumber,
} from "components/Common/Utils"

const ForgetPasswordPage = props => {
  const { t } = useTranslation()

  //meta title
  document.title = t("Forget Password | Yamama")

  const dispatch = useDispatch()
  const { isLoading } = useSelector(state => state.Login)

  const [phone, setPhone] = useState(null)
  const [resetPasswordStep, setResetPasswordStep] = useState(1)
  const [sessionId, setSessionId] = useState(null)
  const [token, setToken] = useState(null)

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    validateOnMount: true,
    initialValues: {
      phone: "",
    },
    validationSchema: Yup.object({
      phone: Yup.string()
        .required(t("Field is required"))
        .matches(
          arabicEnglishDigitRegex,
          t("Phone number must contain only digits")
        ) // Ensures only numbers
        .test(
          "len",
          t("Phone number must be 10 digits long"),
          val => val && val.length <= 10 // Ensures 10 digits
        ),
    }),
    onSubmit: values => {
      const { phone } = values
      const payload = {
        phone_code: "+966",
        phone_number: convertArabicToNumber(phone),
      }
      setPhone(phone)
      dispatch(forgotPassword(payload))
        .then(action => {
          const { statusCode, success, message, data } = action?.payload
          if (statusCode === 200 && success) {
            setSessionId(data?.sessionId)
            // console.log(data?.sessionId)
            dispatch(showAlert({ text: message, type: "success" }))
            setResetPasswordStep(2)
          } else {
            dispatch(showAlert({ text: message, type: "error" }))
          }
        })
        .catch(err => {})
    },
  })

  const ForgotPasswordProperties = createSelector(
    state => state.ForgetPassword,
    forgetPassword => ({
      forgetError: forgetPassword.forgetError,
      forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
    })
  )

  const { forgetError, forgetSuccessMsg } = useSelector(
    ForgotPasswordProperties
  )

  const [otp, setOtp] = useState("")
  const [timer, setTimer] = useState(30) // 5 minutes = 300 seconds
  const [isResendDisabled, setIsResendDisabled] = useState(true)

  useEffect(() => {
    if (resetPasswordStep === 2)
      if (timer > 0) {
        const interval = setInterval(() => {
          setTimer(prev => prev - 1)
        }, 1000)
        return () => clearInterval(interval)
      } else {
        setIsResendDisabled(false)
      }
  }, [timer, resetPasswordStep])

  const handleVerify = () => {
    const payload = {
      sessionId,
      otp: convertArabicToNumber(otp),
    }

    dispatch(otpVerification(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          setToken(data?.token)
          // console.log(data?.token)
          dispatch(showAlert({ text: message, type: "success" }))
          setResetPasswordStep(3)
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  const handleResendOtp = () => {
    // Call API to resend OTP
    // console.log("Resending OTP...")

    const payload = {
      phone_code: "+966",
      phone_number: convertArabicToNumber(phone),
    }
    dispatch(forgotPassword(payload))
      .then(action => {
        const { statusCode, success, message, data } = action?.payload
        if (statusCode === 200 && success) {
          setSessionId(data?.sessionId)
          // console.log(data?.sessionId)
          dispatch(showAlert({ text: message, type: "success" }))
          setIsResendDisabled(true)
          setTimer(300) // Reset timer to 5 minutes
        } else {
          dispatch(showAlert({ text: message, type: "error" }))
        }
      })
      .catch(err => {})
  }

  const formatTime = seconds => {
    const min = Math.floor(seconds / 60)
    const sec = seconds % 60
    return `${min}:${sec < 10 ? `0${sec}` : sec}`
  }

  return (
    <React.Fragment>
      <div className="login_page  h_100 overflow-x-hidden">
        <Container fluid className="h_100">
          <Row
            style={{
              backgroundImage: "url('" + loginBg + "')",
            }}
            className="bg_991"
          >
            <Col lg={6} className="px-0 r_no">
              <div className="left_section position-relative">
                <img src={loginBg} className="login_bg" alt="" />
                <div className="login_footer">
                  <Link to={"/login"}>
                    <img src={SAR_logo} alt="" width={110} height={61} />
                    <img src={alyamama_logo} alt="" width={110} height={61} />
                  </Link>
                </div>
              </div>
            </Col>
            <Col lg={6} className="px-0">
              <div className="right_section g_center h-100 position-relative">
                <img src={rightVector} alt="" className="login_right_vector" />

                {resetPasswordStep == 1 ? (
                  <div className="form_inner">
                    <div className="login_top">
                      <Link to={"/login"}>
                        <img src={SAR_logo} alt="" width={110} height={61} />
                        <img
                          src={alyamama_logo}
                          alt=""
                          width={110}
                          height={61}
                        />
                      </Link>
                    </div>
                    <h1>{t("Password Recovery")}</h1>

                    <div className="p-2">
                      {forgetError && forgetError ? (
                        <Alert color="danger" style={{ marginTop: "13px" }}>
                          {forgetError}
                        </Alert>
                      ) : null}
                      {forgetSuccessMsg ? (
                        <Alert color="primary" style={{ marginTop: "13px" }}>
                          {forgetSuccessMsg}
                        </Alert>
                      ) : null}

                      <Form
                        onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          return false
                        }}
                      >
                        <div className="mb-3">
                          <Label className="form-label">
                            {t("Mobile Number")}
                            <span className="text_danger">*</span>
                          </Label>
                          <Input
                            name="phone"
                            className="form-control"
                            placeholder={t("Mobile Number")}
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.phone || ""}
                            invalid={
                              validation.touched.phone &&
                              validation.errors.phone
                                ? true
                                : false
                            }
                          />
                          {validation.touched.phone &&
                          validation.errors.phone ? (
                            <FormFeedback type="invalid">
                              {validation.errors.phone}
                            </FormFeedback>
                          ) : null}
                        </div>
                        <div className="mt-3 d-grid">
                          <button
                            className={`main_btn ${
                              !validation.isValid ? "disabled-button" : ""
                            }`}
                            type="submit"
                            disabled={isLoading}
                          >
                            {t("Password Recovery")}
                          </button>
                          <p className="privacy_text mt-5">
                            {t(
                              "By using this site, you agree to comply with our"
                            )}{" "}
                            <Link to={"/terms-conditions"}>
                              <span className="text_primary">
                                {t("Terms and Conditions and Privacy Policy.")}
                              </span>
                            </Link>
                          </p>
                        </div>
                      </Form>
                    </div>
                    {/* <div>
                    <p className="text-center text-decoration-underline">
                      <Link to="/login" className="font-weight-medium">
                        Login
                      </Link>{" "}
                    </p>
                  </div> */}
                  </div>
                ) : resetPasswordStep === 2 ? (
                  <div className="otp_verification_page">
                    <div className="otp_form">
                      <div className="otp_form_inner p-3 p-lg-0">
                        <div className="login_top">
                          <Link to={"/login"}>
                            <img
                              src={SAR_logo}
                              alt=""
                              width={110}
                              height={61}
                            />
                            <img
                              src={alyamama_logo}
                              alt=""
                              width={110}
                              height={61}
                            />
                          </Link>
                        </div>
                        <h2>{t("Please enter the sent code.")}</h2>
                        <div className="otp_section">
                          <InputOtp
                            value={otp}
                            onChange={e => setOtp(e.value)}
                            length={6}
                            pt={{ root: { placeholder: "------" } }}
                            mask
                          />
                        </div>
                        <button
                          className="main_btn"
                          onClick={handleVerify}
                          disabled={otp.length !== 6}
                        >
                          {t("Verify")}
                        </button>
                        <p>
                          {isResendDisabled ? (
                            <>
                              {t("You can request a new code after")}{" "}
                              <span>
                                {" "}
                                {formatTime(timer)} {t("minutes")}{" "}
                              </span>
                              {t("please check your registered mobile number.")}
                              .
                            </>
                          ) : (
                            <button
                              className="resend_btn tr_btn"
                              onClick={handleResendOtp}
                              disabled={isLoading}
                            >
                              {t("Resend OTP")}
                            </button>
                          )}
                        </p>
                      </div>
                    </div>
                  </div>
                ) : resetPasswordStep === 3 ? (
                  <div className="form_inner">
                    <div className="login_top">
                      <Link to={"/login"}>
                        <img src={SAR_logo} alt="" width={110} height={61} />
                        <img
                          src={alyamama_logo}
                          alt=""
                          width={110}
                          height={61}
                        />
                      </Link>
                    </div>
                    <ConfirmPassword token={token} isLoading={isLoading} />
                  </div>
                ) : (
                  "-"
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
}

export default withRouter(ForgetPasswordPage)
